<template>
	<div class="s-gray-bg" style="min-height:100vh;" v-infinite-scroll="loadMore"
		infinite-scroll-disabled="isShowBottom" infinite-scroll-distance="10">
		<!-- <div style="padding-top: 1rem;" class="s-gray-bg">
		</div> -->
		<!-- <div class="p-space-between p-box-center-y p-margin30 p-line-height3 p-font1 p-color1 p-bold p-padding-top10">
			<span>运动记录</span>
		</div> -->

		<ul class="p-margin20 p-padding20  p-radius20 p-black s-gray-bg" style="width: auto;"
			v-if="Object.keys(sportMonthListData.MonthDataListJson).length>0">
			<template >
					<li v-for="(val,key,index)  in sportMonthListData.MonthDataListJson" :key="index">
						<div class="p-padding-top20 p-font1-4">
							<span>{{val.time}}</span>
						</div>
						<ul>
							<template>
								<div v-for="(v,k) in val.sportDatas" :key="k"  class="p-white-bg p-font0-8 p-margin-top20  p-padding20  p-radius20">
									<div @click="goToDetailData(v.sportsId)">
										<div class="p-space-between p-box-center-y p-padding-top10">
											<span class="p-space-between p-box-center-y  ">{{formatDateStringByMillSecond(v.sts,$t('common.formatDateMDHMS'))}}</span>
											<span class="p-space-between p-box-center-y  " style="float:right;">{{ $t('sport.timeNum') }} {{getHourBySecondStr(v.ts)=='00'?(''):(getHourBySecondStr(v.ts))}}:{{getMinBySecondStr(v.ts)}}:{{getSecondBySecondStr(v.ts)}}</span>
										</div>
										<div class=" p-box-center-y" style=" padding:0.3rem 0rem 0.3rem 0rem;">
											<img :src="getSportTypeImg(v.sportsType)"
												style="width:4rem; height:4rem;margin:0.5rem 0" />
												<div class="p-margin-left10">
													<div >{{getSportTypeLanguageStrCustom(v.sportsType)}} </div>
													<div  class="p-margin-top10 p-font1-4">{{v.sportskm}}{{$t('sport.kilometre')}}</div>
													<div  class="p-margin-top10 p-space-between p-box-center-x p-box-center-y p-font0-6" >
														<span >
														{{$t('sport.Pacing')}}
														</span> 
														<span class="p-margin-left10 p-box-center-y" style="padding-top: 0.1rem;">
														{{v.avgPace}}
														</span> 
														<span class="p-margin-left20">
															{{$t('sport.consume')}}
														</span> 
														<span class="p-margin-left10 p-box-center-y" >
														{{v.consume}}	{{$t('sport.Kilocalorie')}}
														</span> 
													</div>
												</div>
										</div>
									</div>

								</div>
							</template>
						</ul>
					</li>
			</template>
		</ul>
		<div v-if="sportMonthListData.isShowBottom" class="p-line-height3 p-font0-8 p-color3 p-center">{{$t('common.nowLoadingMoreData')}}</div>
		<loadingContent v-else-if="sportMonthListData.isLoading"></loadingContent>
		<noContent v-else-if="(!sportMonthListData.isPullDown && !sportMonthListData.isLoading) && sportMonthListData.isNoData">
		</noContent>
		<loadedAllData v-else-if="(!sportMonthListData.isPullDown && !sportMonthListData.isLoading) && sportMonthListData.isBottom">
		</loadedAllData>
	</div>
</template>

<script>
	import loadingContent from "../components/loading/loadingContent";
	import noContent from "../components/loading/noContent";
	import loadedAllData from "../components/loading/loadedAllData";
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	import {
		getKCalorie,
		getCalorie,
		getHourBySecond,
		getMinBySecond,
		getSecondBySecond,
		getHourBySecondStr,
		getMinBySecondStr,
		getSecondBySecondStr,
		formatDateStringByMillSecond,
		getSportTypeStr,
		getSportTypeLanguageStr,
		getSportTypeImg,
	} from '@/utils/methods.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loadingContent,
			noContent,
			loadedAllData,
			monthDataSize: 0,
			isLoading: true,
			isNoData: false, // 没有数据
			isPullDown: false,
			isShowBottom: false,
			isBottomNoMore: false,
			isFrist: true,
			lastTimeFormat: '',
		},
		data() {
			return {
				sportTypeImg:'../assets/img/icon_sport_type_0.png',
				title: '',
				// offset:0,
				// day: '',
			// 	MonthDataListJson: [{
			// 	sportDate:'2021-10',
			// 	sportDatas:[{
			// 		sportTime:1633395152319,
			// 		sportTitle:'户外步行',
			// 		sportType:1,
			// 		counteStep:2000,
			// 		timeSecond:300,
			// 		distance:5.2,
			// 		pace:300,
			// 	},{sportTitle:'户外骑行行',
			// 	sportTime:1633308752000,
			// 		sportType:2,
			// 		counteStep:10000,
			// 		timeSecond:300,
			// 		distance:11,
			// 		pace:200,}]

			// },{
			// 	sportDate:'2021-09',
			// 	sportDatas:[{	
			// 		sportTime:1630803152000,
			// 		sportTitle:'户外步行',
			// 		sportType:1,
			// 		counteStep:2000,
			// 		timeSecond:300,
			// 		distance:3,
			// 		pace:20,}]
			// }],
			}
		},
		methods: {
			getKCalorie,
			getCalorie,
			getHourBySecond,
			getMinBySecond,
			getSecondBySecond,
			formatDateStringByMillSecond,
			getHourBySecondStr,
			getMinBySecondStr,
			getSecondBySecondStr,
			getSportTypeStr,
			getSportTypeLanguageStr,
			getSportTypeImg,
			getSportTypeLanguageStrCustom(type){
				console.log("getSportTypeLanguageStrCuston  ",type);
				return getSportTypeLanguageStr(type,this)
			},
			goToDetailData(value){
				this.$router.push({
				    path: '/sportReportLite',
				    query: {
				      pid: this.$route.query.pid,
					  sportId: value,
					  language:this.$route.query.language
				    }
				  })
			},
			// 获取不同类型数据
			getData(offsetValue) {
				console.log("getData111");
				this.sportMonthListData.isLoading = true;
				console.log("getData");
				if (0 == offsetValue) {
					this.getSportList(0);
				} else {
					this.getSportList(offsetValue);
				}
			},
			loadMore() {
				// //可滚动容器的高度
				// let innerHeight = this.$refs.scroll.clientHeight;
				// //屏幕尺寸高度
				// let outerHeight = document.documentElement.clientHeight;
				// //可滚动容器超出当前窗口显示范围的高度
				// let scrollTop = document.documentElement.scrollTop;
				// //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
				// console.log(innerHeight + " " + outerHeight + " " + scrollTop);
				// if (innerHeight <= outerHeight + scrollTop) {
				// 	//加载更多操作
				// console.log("loadmore");
				if(this.isFrist){
					this.isFrist=false;
					return;
				}
				if (!this.sportMonthListData.isBottomNoMore) {
					console.log("loadmore");
					if(!this.isLoading){
						if (!this.sportMonthListData.isShowBottom) {
							this.sportMonthListData.isShowBottom = true;
							console.log("onReachBottom:------- ", this.sportMonthListData.monthDataSize);
							this.getData(this.sportMonthListData.monthDataSize);
						}
					}
				} else {
					console.log("loadmore  no more");
				}

				// }
			}

		},
		mounted(){
			this.isFrist=true;
			this.getData(0);
		},
		created() {
		},
	}
</script>

<style scoped>

</style>
